"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Checkbox: function() {
        return _Checkbox.Checkbox;
    },
    checkboxClassNames: function() {
        return _Checkbox.checkboxClassNames;
    },
    renderCheckbox_unstable: function() {
        return _Checkbox.renderCheckbox_unstable;
    },
    useCheckboxStyles_unstable: function() {
        return _Checkbox.useCheckboxStyles_unstable;
    },
    useCheckbox_unstable: function() {
        return _Checkbox.useCheckbox_unstable;
    }
});
const _Checkbox = require("./Checkbox");
